import { ReactComponent as CheckIcon } from "assets/icons/check.svg";
import MessageSuccess from "components/Message/Success";
import { useMessageContext } from "providers/MessageProvider";
import React from "react";
import { StyledInnerContainer } from "./styles";

const Success: React.FC = () => {
  const { isFormSuccessVisible } = useMessageContext();

  return (
    <StyledInnerContainer isVisible={isFormSuccessVisible}>
      <CheckIcon />
      <div className="ml-30 fill">
        <MessageSuccess />
      </div>
    </StyledInnerContainer>
  );
};

export default Success;
